window.$ = require('jquery');
window.$ = require("jquery-validation");
// window.Swiper = require('swiper/bundle');
// window.flowbite = require("flowbite");
// // datepicker = require("flowbite/dist/datepicker");
// window.iziToast = require("izitoast");
// window.AOS = require('aos');
// window.Quill = require('quill');
// window.tw_elements = require('tw-elements');
// window.moment = require('moment');

import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});